import React, {useState} from 'react';
import {DropdownMenu} from "../../components/menus/DropdownMenu";
import OpenFolder from "../../resources/icon/folder-open.png";
import Folder from "../../resources/icon/folder.png";
import {ShadInput} from "../../shadCn/components/ui/ShadInput";
import {handleActiveError, handleActiveToast} from "../../components/sonner/ToastBasic";
import {ArrowUturnDownIcon} from "@heroicons/react/16/solid";
import NoSelected from "../../components/Utils/NoSelected";
import {useDispatch, useSelector} from "react-redux";
import {changeSelectCreateChildCodeIdx, changeSelectUpdateCodeIdx} from "../../redux/slice/codeSlice";
import {refresh} from "../../redux/slice/apiSlice";

function RecursiveList({data, colName, depth = 0, setTarget, creator, updater, deleter, readOnly, selectedId}) {

    const [expandedMenus, setExpandedMenus] = useState({});
    const [updateCodeName, setUpdateCodeName] = useState("");
    const [customCodeName, setCustomCodeName] = useState("");
    const selectUpdateCodeIdx = useSelector(state => state.code.selectUpdateCodeIdx);
    const selectCreateChildCodeIdx = useSelector(state => state.code.selectCreateChildCodeIdx);
    const dispatch = useDispatch();

    //메뉴 확장
    const toggleSubMenu = (menuId) => {
        setExpandedMenus((prevState) => {
            return {
                ...prevState,
                [menuId]: !prevState[menuId],
            }
        });
    };

    //클릭한 코드값을 검색컴포넌트의 부모로 넘겨주기 위한 클릭 리스너
    const clickListener = (code) => {
        setTarget(code);
    }
    // 삭제버튼 클릭
    const openDelete = async (codeId) => {

        return await deleter(codeId);

    }

    //수정버튼 클릭
    const openUpdate = (codeId, codeName) => {
        setUpdateCodeName(codeName);
        dispatch(changeSelectUpdateCodeIdx(codeId));
        dispatch(changeSelectCreateChildCodeIdx(0));
    }

    //하위등록버튼 클릭
    const openCreateUnder = (codeId) => {
        setExpandedMenus(prev => {
                return {...prev, [codeId]: true}
            }
        );
        dispatch(changeSelectUpdateCodeIdx(-1));
        dispatch(changeSelectCreateChildCodeIdx(codeId));
    }

    // 하위코드 등록
    const createCodeHandler = async (e, item) => {
        if (e.key === 'Enter') {
            const customCode = {
                parentId : item.id,
                parent:{id:item.id},
                name: customCodeName,
            }
            return  await creator(customCode);
        }
    }

    const updateCodeHandler = async (e, item) => {
        if (e.key === 'Enter') {
            dispatch(changeSelectUpdateCodeIdx(0))
            const response =  await updater({...item, name: updateCodeName })
            return response;
        }

    }

    return (
        <ul className={`folder ${depth > 0 ? `pl-5` : ``}`}>
            {data.length > 0 ? (
                (data.map((item, index) =>
                    <li key={item.id} className={`${depth ==0 ? `top-parent`:``}`}>
                        {selectUpdateCodeIdx !== item.id ? (
                            <div className={`bg-white compo-each h-[30px] flex${selectedId != null && selectedId === item.id ? " is-selected" : ""}`}>
                                {expandedMenus[item.id] ? (

                                    <img onClick={() => toggleSubMenu(item.id)} src={OpenFolder}
                                         className="expandable-folder cursor-pointer " alt="folder-image"/>


                                ) : (

                                    <img onClick={() => toggleSubMenu(item.id)} src={Folder}
                                         className="expandable-folder cursor-pointer " alt="folder-image"/>

                                )}
                                <p className={"truncate cursor-pointer w-full"}
                                   onClick={() => clickListener(item)}>{colName ? item[colName] :item.name}</p>
                                {!readOnly &&
                                <DropdownMenu
                                    handleDelete={deleter ? () => openDelete(item.id) : null}
                                    handleUpdate={ updater ? () => openUpdate(item.id, colName ? item[colName] :item.name) : null}
                                    handleCreateChild={creator ? () => openCreateUnder(item.id) : null}
                                />
                                }

                            </div>
                        ) : (
                            <div className={"ml-1 no-bg flex gap-3 items-center"}>
                                <ShadInput className={"mb-2 "} value={updateCodeName}
                                           onChange={(e) => setUpdateCodeName(e.target.value)}
                                           onKeyDown={(e) => updateCodeHandler(e, item)}
                                />
                                <ArrowUturnDownIcon className={"mr-3 ml-[-5px] rotate-90 w-4 mb-1 "}
                                                    onClick={() => dispatch(changeSelectUpdateCodeIdx(0))}/>
                            </div>
                        )}

                        { selectCreateChildCodeIdx === item.id &&
                            <>
                                <div className={"flex gap-3 items-center ml-5"}>
                                    <ShadInput className={`mb-2`} value={customCodeName}
                                               onChange={(e) => setCustomCodeName(e.target.value)}
                                               onKeyDown={(e) => createCodeHandler(e, item)}/>
                                    <ArrowUturnDownIcon className={"mr-4 ml-[-5px] rotate-90 w-4 mb-1 "}
                                               onClick={() => dispatch(changeSelectCreateChildCodeIdx(0))}/>
                                </div>
                            </>
                        }
                        {
                            <>
                                {expandedMenus[item.id] && item.children && item.children.length > 0 &&
                                    (<RecursiveList
                                        data={item.children} depth={depth + 1} setTarget={setTarget}
                                        creator={creator} updater={updater} deleter={deleter}
                                        readOnly={readOnly}
                                        selectedId={selectedId}
                                    />)
                                }
                            </>
                        }
                    </li>
                ))
            ):(
                <>
                    <NoSelected title={"그룹을 생성하세요."} height={550}/>
                </>
            )
            }

        </ul>
    )
}

export {RecursiveList}